import request from "@/utils/request/request";

export default {
  //平台列表
  GetPtList(params) {
    return request({ url: "pc/platformList", method: "get", params });
  },
  //行业列表
  GetHyList(params) {
    return request({ url: "pc/industryList", method: "get", params });
  },
  //颜色列表
  GetYsList(params) {
    return request({ url: "pc/colorList", method: "get", params });
  },
  //项目列表
  GetXmList(params) {
    return request({ url: "pc/lists", method: "get", params });
  },
  //项目详情
  GetXmDetail(params) {
    return request({ url: "pc/detail", method: "get", params });
  },
  //获取用户信息
  GetUserInfo(params) {
    return request({ url: "user/index", method: "get", params });
  },
  //手机验证码登陆
  Login(data) {
    return request({ url: "pc/mobilelogin", method: "post", data:data });
  },
  //发送验证码
  Send(data) {
    return request({ url: "sms/send", method: "post", data:data });
  },
  //获取微信二维码
  GetCode(params) {
    return request({ url: "pc/code", method: "get", params });
  },
  //获取微信二维码注册登陆
  GetWxLogin(params) {
    return request({ url: "pc/wxlogin", method: "get", params });
  },
  //用户协议
  GetYhxy(params) {
    return request({ url: "wxmp/yhxy", method: "get", params });
  },
  //隐私政策
  GetYszc(params) {
    return request({ url: "wxmp/yszc", method: "get", params });
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js